"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTertiaryVariantStyles = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _utils2 = require("../utils");
var _constants = require("./constants");
var _interfaces = require("./interfaces");
var _variantStyles = require("./variantStyles");
const getTertiaryVariantStyles = _ref => {
  let {
    isDestructive,
    isDisabled,
    size,
    iconOnly
  } = _ref;
  const borderRadius = (0, _utils.token)('dimensions.border.radius.round');
  const tokenSuffix = isDisabled ? 'disabled' : 'default';
  const commonStyles = {
    borderColor: _constants.TRANSPARENT_COLOR,
    display: 'flex',
    borderRadius,
    minHeight: (0, _utils2.px)(_utils2.A11Y_MIN_SIZE),
    padding: size === _interfaces.ButtonSize.Small ? //TODO make this vertical padding 4px (spacing.100) in 5.x to match with figma
    "".concat((0, _utils2.px)(2), " ").concat((0, _utils.token)('dimensions.spacing.300')) : //TODO make this vertical padding 8px (spacing.200) and horizontal padding 24px (spacing.400) in 5.x to match with figma.
    "".concat((0, _utils2.px)(6), " ").concat((0, _utils.token)('dimensions.spacing.300'))
  };
  if (iconOnly) {
    commonStyles.minWidth = (0, _utils2.px)(_utils2.A11Y_MIN_SIZE);
    commonStyles.padding = size === _interfaces.ButtonSize.Small ? (0, _utils.token)('dimensions.spacing.100') : (0, _utils.token)('dimensions.spacing.200');
  }
  let restStyles = {
    backgroundColor: _constants.TRANSPARENT_COLOR,
    color: (0, _utils.token)("color.link.primary-".concat(tokenSuffix)),
    ...commonStyles
  };
  let stateStyles = (0, _variantStyles.getStateStylesWithOutlineOnFocus)({
    'focus-visible': {},
    hover: {
      backgroundColor: (0, _utils.token)('color.action.tertiary.bg-hover'),
      color: (0, _utils.token)('color.link.primary-hover')
    },
    active: {
      backgroundColor: (0, _utils.token)('color.action.tertiary.bg-pressed'),
      color: (0, _utils.token)('color.link.primary-pressed')
    }
  }, (0, _utils.token)('color.border.border-focus'), restStyles.backgroundColor);
  if (isDestructive) {
    restStyles = {
      backgroundColor: _constants.TRANSPARENT_COLOR,
      color: (0, _utils.token)("color.link.critical-".concat(tokenSuffix)),
      ...commonStyles
    };
    stateStyles = (0, _variantStyles.getStateStylesWithOutlineOnFocus)({
      'focus-visible': {},
      hover: {
        backgroundColor: (0, _utils.token)('color.action.tertiary.critical-bg-hover'),
        color: (0, _utils.token)('color.link.critical-hover')
      },
      active: {
        backgroundColor: (0, _utils.token)('color.action.tertiary.critical-bg-pressed'),
        color: (0, _utils.token)('color.link.critical-pressed')
      }
    }, (0, _utils.token)('color.border.border-focus'), restStyles.backgroundColor);
  }
  if (isDisabled) {
    stateStyles = (0, _variantStyles.getStateStylesWithOutlineOnFocus)({
      active: {},
      'focus-visible': {},
      hover: {}
    }, (0, _utils.token)('color.border.border-focus'), restStyles.backgroundColor);
  }
  return {
    ...restStyles,
    ...stateStyles
  };
};
exports.getTertiaryVariantStyles = getTertiaryVariantStyles;